import { useQuery } from '@tanstack/react-query';
import type { GetWidgetChatResponse } from 'server';
import { appFetch } from './appFetch';
import { widgetKeys } from './keys';

export const useGetChat = (chatId: string) => {
  return useQuery({
    queryKey: widgetKeys.chat(chatId),
    queryFn: async (): Promise<GetWidgetChatResponse> => {
      const response = await appFetch<GetWidgetChatResponse>(`/app/public/widget/chats/${chatId}`);
      return response;
    },
    enabled: !!chatId
  });
};
